module.exports = __webpack_public_path__ + "img/pencil-line.76efa976.svg";